import { GROUP_DETAIL } from '../../../pages/Groups/pages/GroupDetail/GroupDetail';

export const ACTION_NAMES = {
  GROUP_DETAIL
};

export type IActionKey = keyof typeof ACTION_NAMES;
